/* eslint-disable class-methods-use-this */
import React from 'react';
import generalCss from '../../styles/components/checkout-steps/payment/payment-method-selector.scss';
// eslint-disable-next-line import/no-cycle
import PaymentFormConnector from '../../../containers/checkout-steps/payment-form-connector';
import spreeStore from '../../../store';
import actions from '../../../actions';

const CREDIT_CARD_OPTIONS = ['141', '16'];

class PaymentMethodCreditCard extends React.Component {
    onNext() {
        if (!spreeStore.getState().order.isFinalStepHappening) {
            spreeStore.dispatch(actions.setIsFinalStepHappening(true));
            spreeStore.dispatch(actions.displayLoader());
            window.scrollTo(0, 0);

            spreeStore.dispatch(actions.goToNextStep(this.props.order, this.props.locale, {}))
                .then(
                    () => {
                    },
                    (error) => {
                        console.log(error);
                    },
                )
                .finally(() => {
                    spreeStore.dispatch(actions.setIsFinalStepHappening(false));
                    spreeStore.dispatch(actions.hideLoader());
                });
        }
    }

    isThisOptionSelected() {
        return this.props.method && this.props.optionSelected && this.props.method.id === this.props.optionSelected.id;
    }

    shouldNextBeEnabled() {
        return this.props.order.isCreditCardValidated;
    }

    selectionToggle() {
        if (this.props.onOptionSelected) {
            this.props.onOptionSelected(this.props.method);
        }
    }

    render() {
        return (
            <div>
                <div>
                    <input
                        type="radio"
                        id={this.props.method.id}
                        name="payment_method"
                        value={this.props.method.name}
                        onChange={() => {
                            this.selectionToggle();
                        }}
                        defaultChecked={this.props.method.isDefault}
                    />
                    <label className={generalCss.pms__option__label} htmlFor={this.props.method.id}>{this.props.method.name}</label>
                </div>
                {CREDIT_CARD_OPTIONS.includes(this.props.optionSelected.id) && (
                    <PaymentFormConnector />
                )}
            </div>
        );
    }
}

export default PaymentMethodCreditCard;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment/payment-method-credit-card.js
 **/